export const groupBookingsByDay = bookings => {
  if ([undefined, null].includes(bookings)) return null

  let output = {}

  if (Array.isArray(bookings)) {
    bookings.forEach(booking => {
      // Add to out the session at it's day
      const sessionDay = booking.sessionDay

      if (!output[sessionDay]) {
        output[sessionDay] = []
      }
      output[sessionDay].push(booking)
    })
  }

  return output
}

// Takes bookings for a week and removes the grouping by day
export const flattenBookingsByWeek = (bookings = {}) => {
  let output = []

  for (const day in bookings) {
    if (bookings.hasOwnProperty(day)) {
      output.push(...bookings[day])
    }
  }

  return output
}



// WEBPACK FOOTER //
// ./src/care-enrolments/details/ccs-gov-enrolments/actions/update-enrolment-schedule/helpers.js